import useAnalyticStore from '../../analyticStore/useAnalyticStore';
import useDashboardStore from '../../dashboardStore/useDashboardStore';
import useThirdPartyStore from '../../thirdPartyStore/useThirdPartyStore';
import { AsyncExternalLink } from '../types/AsyncExternalLink';

export const getEmbeddedInsuranceVerificationLink = (): AsyncExternalLink => {
  const {
    computed: {
      vehicleApplicationAutopayNumber,
      vehicleBrand,
      vehicleEmbeddedInsuranceLeadId,
      vehicleId,
    },
  } = useDashboardStore.getState();
  const { getEmbeddedInsuranceVerificationURL } = useThirdPartyStore.getState();
  const { sendEmbeddedInsuranceVerificationRedirectAnalytics } =
    useAnalyticStore.getState();

  return {
    getUrl: async (): Promise<string> => {
      const url = await getEmbeddedInsuranceVerificationURL({
        brandName: vehicleBrand,
        leadId: vehicleEmbeddedInsuranceLeadId,
        vehicleId,
      });
      return url;
    },
    kind: 'async-external',
    onAnalytics: (): void => {
      sendEmbeddedInsuranceVerificationRedirectAnalytics(
        vehicleApplicationAutopayNumber,
      );
    },
  };
};
